import { format } from 'date-fns';
import { allTimezones } from 'react-timezone-select';
import formatYaml from '../../config/address_format.yml';
import { LbPer1kg } from '../constants/weight';
var MONEY_FORMATTERS = {
    JPY: Intl.NumberFormat('ja-JP', {
        style: 'currency',
        currency: 'JPY',
    }),
    USD: Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    }),
    EUR: Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'EUR',
    }),
    KRW: Intl.NumberFormat('ko-KR', {
        style: 'currency',
        currency: 'KRW',
    }),
    TWD: Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'TWD',
    }),
};
export var formatMoneyAmount = function (value, currency) {
    var formatter = MONEY_FORMATTERS[currency];
    var valueAsNumber = typeof value === 'string' ? parseFloat(value) : value;
    return formatter.format(valueAsNumber);
};
export var validURL = function (str) {
    var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
    return !!pattern.test(str);
};
export var kgFobPriceToLbFobPrice = function (kgFobPrice) {
    return Math.ceil((kgFobPrice / LbPer1kg) * 100) / 100;
};
export var feePer1kgToFeePer1lb = function (feePer1kg) {
    return Math.ceil((feePer1kg / LbPer1kg) * 100) / 100;
};
export var weightFormat = function (weight) {
    var weightNum = weight;
    if (typeof weight === 'string') {
        weightNum = parseFloat(weight);
    }
    return "".concat(weightNum.toLocaleString(), "Kg");
};
export var formatPercentage = function (percentage) {
    if (!percentage)
        return '';
    return "".concat(parseFloat(percentage).toLocaleString(), "%");
};
export var formatDateTimeWithOffset = function (datetime) {
    if (!datetime)
        return '';
    return format(new Date(datetime), 'yyyy-MM-dd HH:mm (zzzz)');
};
export var formatWaterActivity = function (waterActivity) {
    if (!waterActivity)
        return '';
    return "".concat(waterActivity, "Aw");
};
export var formatTimeZoneName = function (timeZoneName) {
    return "".concat(timeZoneName, " - ").concat(allTimezones[timeZoneName]);
};
export var formatAddress = function (address, withPostalCode) {
    if (withPostalCode === void 0) { withPostalCode = true; }
    var target = withPostalCode
        ? formatYaml['format_with_postal_code']
        : formatYaml['format_without_postal_code'];
    var formatter = target[address.countryCode] || target['default'];
    return formatter
        .replace('%{postal_code}', address.postalCode)
        .replace('%{prefecture}', address.prefecture)
        .replace('%{city}', address.city)
        .replace('%{address}', address.address)
        .replace('%{building}', address.building)
        .replace(/^ *, */, '');
};
